import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const PutShopIntroductionRequestSchema = z
  .object({
    description: z.string(),
  })
  .describe('PutShopIntroductionRequestSchema');

const PutShopIntroductionResponseDataSchema = z
  .object({
    curatorId: z.string(),
    description: z.string(),
  })
  .describe('PutShopIntroductionResponseDataSchema');

const PutShopIntroductionResponseSchema = createApiResponseSchema(
  PutShopIntroductionResponseDataSchema,
);

type PutShopIntroductionRequest = z.infer<typeof PutShopIntroductionRequestSchema>;
type PutShopIntroductionResponse = z.infer<typeof PutShopIntroductionResponseSchema>;

export const putShopIntroduction = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutShopIntroductionRequestSchema),
    (request: PutShopIntroductionRequest) =>
      executeStandardRequest(async () =>
        privateHttpClient.put<PutShopIntroductionResponse>(
          profileApiPath.putShopIntroduction,
          request,
        ),
      ),
    validateApiResponse(PutShopIntroductionResponseSchema),
  ),
);
